module.exports = __webpack_public_path__ + "static/img/s35.9a92e14b.png";